export class GeoLabel {
  constructor(init: Partial<GeoLabel> = {}) {
    this.cityLabel = init.cityLabel || ''
    this.zipCodeLabel = init.zipCodeLabel || ''
  }
  cityLabel: string
  zipCodeLabel: string
}
